/* One shared player controller for the panel picker and Mini explainer. */
(() => {
  if (window.rhVideoDialogReady) return;
  window.rhVideoDialogReady = true;
  const triggers = new WeakMap();
  let active = null;
  let previousOverflow = '';

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-rh-video-open]');
    if (open) {
      const dialog = document.getElementById(open.getAttribute('aria-controls'));
      if (!dialog || dialog.open) return;
      if (active?.open) active.close();
      const video = dialog.querySelector('video');
      video.src = matchMedia('(max-width: 699px)').matches ? dialog.dataset.rhVideoMobile : dialog.dataset.rhVideoDesktop;
      triggers.set(dialog, open);
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      active = dialog;
      document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-rh-video-close]').focus();
      // Play before returning from the click handler to preserve user activation.
      const attempt = video.play();
      if (attempt?.catch) attempt.catch(() => { video.controls = true; });
      return;
    }
    const close = event.target.closest('[data-rh-video-close]');
    if (close) close.closest('dialog')?.close();
    const dialog = event.target.closest('.rh-video-dialog');
    if (dialog && event.target === dialog) dialog.close();
  });

  // Native dialog traps focus and handles Escape; close runs for both Escape and buttons.
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('.rh-video-dialog')) return;
    const video = dialog.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    if (active === dialog) {
      active = null;
      document.body.style.overflow = previousOverflow;
    }
    triggers.get(dialog)?.focus();
  }, true);
})();
